import { useEffect } from 'react';

interface StructuredDataProps {
  data: Record<string, any>;
}

/**
 * Componente para injetar Structured Data (JSON-LD) no head
 * 
 * @example
 * ```tsx
 * import { medicalWebPageSchema } from '@/data/seoSchemas';
 * 
 * <StructuredData data={medicalWebPageSchema} />
 * ```
 */
export function StructuredData({ data }: StructuredDataProps) {
  useEffect(() => {
    const scriptId = `structured-data-${data['@type']}`;
    
    // Remove script anterior se existir
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.remove();
    }

    // Cria novo script
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      // Cleanup ao desmontar
      const scriptToRemove = document.getElementById(scriptId);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [data]);

  return null;
}
